import * as z from 'zod';

export const permissionListModel = z.object({
    permissions: z.array(z.string()),
    catalogueEnforced: z.boolean(),
});

export type PermissionList = z.infer<typeof permissionListModel>;
